import { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useUpdateServicesSetting } from './useUpdateServicesSetting';

type ServiceFormData = {
  invoice_download_agent: boolean;
};

type UseAiAgentServicesSettingProps = {
  invoice_download_agent: boolean;
  setIsEditingServices: (isEditingServices: boolean) => void;
};

export const useAiAgentServicesSetting = ({
  invoice_download_agent,
  setIsEditingServices,
}: UseAiAgentServicesSettingProps) => {
  const { updateServicesSetting, isUpdating } = useUpdateServicesSetting();
  const methods = useForm<ServiceFormData>({
    mode: 'all',
    defaultValues: { invoice_download_agent },
  });
  const { handleSubmit } = methods;

  useEffect(() => {
    methods.reset({ invoice_download_agent });
  }, [invoice_download_agent, methods]);

  const handleEdit = useCallback(() => {
    setIsEditingServices(true);
  }, [setIsEditingServices]);

  const handleCancel = useCallback(() => {
    setIsEditingServices(false);
    methods.reset({
      invoice_download_agent,
    });
  }, [invoice_download_agent, methods, setIsEditingServices]);

  const onSubmit = useCallback(
    (data: ServiceFormData) => {
      updateServicesSetting(data, handleCancel);
    },
    [updateServicesSetting, handleCancel]
  );

  const handleSave = useCallback(() => {
    handleSubmit(onSubmit)();
  }, [handleSubmit, onSubmit]);

  return {
    methods,
    handleEdit,
    handleCancel,
    handleSave,
    isUpdating,
  };
};
